if (!customElements.get('dd-ingredient-explorer')) {
  customElements.define('dd-ingredient-explorer', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const items = Array.from(this.querySelectorAll('.dd-pdp-ingredient'));
      const open = item => { items.forEach(other => { other.open = other === item; }); };
      items.forEach(item => {
        item.querySelector('summary').addEventListener('click', event => {
          if (event.pointerType === 'mouse') { event.preventDefault(); open(item); }
        }, { signal });
        item.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') open(item); }, { signal });
        item.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && !item.contains(document.activeElement)) item.open = false; }, { signal });
        item.addEventListener('toggle', () => { if (item.open) items.forEach(other => { if (other !== item) other.open = false; }); }, { signal });
        item.addEventListener('focusout', event => { if (!item.contains(event.relatedTarget)) item.open = false; }, { signal });
      });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape') items.forEach(item => { item.open = false; });
      }, { signal });
      document.addEventListener('pointerdown', event => {
        items.forEach(item => { if (!item.contains(event.target)) item.open = false; });
      }, { signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
